import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../context/authContext";
import { useOperador } from "../../Hooks/useOperador";
import { FaUserAlt, FaIdCard } from "react-icons/fa";
import api from "../../Services/api";
import MenuLateral from "../../Componentes/MenuLateral";
import MenuSuperior from "../../Componentes/MenuSuperior";
import "./listaClientesAuditoria.css";

const ListaClientesAuditoria = () => {
    const [clientes, setClientes] = useState([]);

    const { isAuthenticated, authReady, } = useAuthContext();
    const { IDOperador, nome, operador } = useOperador();
    const navigate = useNavigate();

    let idFormatado = String(IDOperador).padStart(6, '0');

    useEffect(() => {
        if (operador && operador.IDOperador && isAuthenticated && authReady) {
            inicializaTela();
        } else {
            navigate("/Menu");
        }
    }, [operador]);

    async function inicializaTela() {
        let retorno = await buscaClientes(IDOperador);
        console.log(retorno);
        if (retorno && retorno.data && Array.isArray(retorno.data.Clientes)) {
            setClientes(retorno.data.Clientes);
        } else {
            console.warn("Clientes não encontrados ou estrutura inesperada:", retorno.data);
            setClientes([]);
        }
    }

    async function buscaClientes(IDoperador) {
        try {
            const response = await api.get('/clientes/operador/' + IDoperador);
            return response;

        } catch (error) {
            console.log(error);
            return error;
        }
    }

    const handleCardClick = (IDClienteAuditoria) => {
        // setIDClienteAberto(id);
        navigate(`/AuditoriaSecao/${IDClienteAuditoria}`);

    };

    return (
        <div className="lista-clientes-auditoria-page">
            <div className="menu-container-menu">
                <MenuLateral />
                <div id="painel_principal_menu" align="center">
                    <MenuSuperior userId={idFormatado} userName={nome} />
                    <h4 style={{ width: '100%', textAlign: 'center', paddingTop: '50px' }}>
                        CADASTRO DE SEÇÕES - AUDITORIA
                    </h4>

                    <div className="lcapage-lista-clientes-wrapper">
                        <h3>Selecione o cliente:</h3>
                        <div
                            className="lcapage-card-container"
                        >
                            {clientes.map((cliente) => (
                                <div
                                    key={cliente.IDCliente}
                                    className="lcapage-card-cli"
                                    onClick={() => handleCardClick(cliente.IDCliente)}
                                >
                                    <div className="lcapage-card-content">
                                        <h3 style={{ textAlign: "start", paddingLeft: "5%" }}>
                                            <FaUserAlt style={{ marginRight: "8px" }} />
                                            {cliente.nome}
                                        </h3>
                                        <div className="row">
                                            <div
                                                className="col-sm-8"
                                                // eslint-disable-next-line react/no-unknown-property
                                                align="left"
                                                style={{ fontSize: "0.8em", paddingLeft: "5%" }}
                                            >
                                                <>
                                                    <FaIdCard style={{ marginRight: "8px", marginLeft: "15px" }} />
                                                    CNPJ: {cliente.cnpj}
                                                </>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ListaClientesAuditoria;
